ulekareApp.factory('SubscriptionFormStorage', function(C){
	var storageName = 'SubscriptionFormStorage';
	var pathnameArr = window.location.pathname.split('/');

	if (pathnameArr.length === 3) {
		storageName += pathnameArr.pop();
	}

	var ds = new DataStorage(storageName, 'sessionStorage');
	ds.getId = function() {
		return this.get('id');
	};
	ds.hasId = function() {
		return this.data.id;
	};
	ds.getPaymentId = function() {
		return this.get('paymentId');
	};
	ds.isLastUpdateOlderThan = function(seconds) {
		if (!this.data.lastUpdate) {
			return false;
		}
		var interval = Date.now() - this.data.lastUpdate;
		return (interval > seconds * 1000);
	};
	return ds;
});
